export enum Actions {
  SET_CONNECTED = "SET_CONNECTED",
  UPDATE_RESULT = "UPDATE_RESULT",
  DELETE_RESULT = "DELETE_RESULT",
  UPDATE_HELP_MODAL = "UPDATE_HELP_MODAL",
}
